module.exports = __webpack_public_path__ + "img/5-5-2.082b9586.jpg";